'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import userSetAction from '../../actions/userSetAction';
import userSetStore from '../../stores/userSetStore';
import renderImage from './userSetImg';
import UserSetModal from './userSetModal';
import SupervisorModal from './supervisorModal';
//import UserPermission from './userPermission';

class UserSetForm extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);

        this.handleEdit = this.handleEdit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.addSupervisor = this.addSupervisor.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.shouldSupModalClose = this.shouldSupModalClose.bind(this);
        this.state = {
            firstName: "",
            middleName: "",
            lastName: "",
            staffId: "",
            typeIdentidy: "",
            identidyNo: "",
            gender: 0,
            dob: "",
            race: 0,
            nationality: "",
            employmentDate: "",
            department: 0,
            role: 0,
            officeExtNo: "",
            email: "",
            password: "",
            confirmPassword: "",
            userImage: "",
            streetName: "",
            blkNo: "",
            unitNo: "",
            postal: "",
            homeTel: "",
            handPhone: "",
            emgName: "",
            emgContactNo: "",
            emgRelationship: "",
            comHandphone: { number: "", model: "", serial: "" },
            comLaptop: { number: "", model: "", serial: "" },
            comCabcard: { number: "", model: "", serial: "" },
            education: "",
            school: "",
            supervisor: [],
            startWork: "09:00",
            endWork: "17:30",
            startLunch: "13:00",
            endLunch: "14:00",
            status: 0,
            //permission: [],
            warningMsg: "",
            //permissionList: userSetStore.getState().permissionList,
            isSucceed: userSetStore.getState().isSucceed,
            processing: userSetStore.getState().processing,
            modalClose: false,
            modalDelClose: false,
            otClaim: false,
            remark: "",
        };
    }
    static defaultProps = {
        departmentTxt: [
            "Accounts", "HR", "Operations", "Management", "IT", "Admin", "A4FM"
        ],
        roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive",
            "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology",
            "Managing Director", "Director", "Other", "Cleaner Supervisor",
            "Cleaner", "Landscaper", "Electrician", "Caretaker",
            "Portfolio Manager", "Team Manager","Senior Admin Executive"
        ],
    };
    componentDidMount() {
        userSetStore.listen(this.onChange);
        /*
        if (!this.state.processing) {
            userSetAction.processing(true);
            userSetAction.getPermissionList();
        }
        */
    }
    componentWillUnmount() {
        userSetStore.unlisten(this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isSucceed && prevState.isSucceed != this.state.isSucceed) {
            this.setState({ modalClose: true });
        }
    }
    onChange(state) {
        console.log(state);
        this.setState({
            isSucceed: state.isSucceed,
            processing: state.processing,
            //permissionList: state.permissionList,
        });
    }
    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
        });
    }
    addSupervisor() {
        this.setState({
            modalSupClose: true
        });
    }
    handleEdit(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let value = e.target.value;
        let { comHandphone, comLaptop, comCabcard } = this.state;
        switch (index) {
            case 0:
                this.setState({ firstName: value });
                break;
            case 1:
                this.setState({ middleName: value });
                break;
            case 2:
                this.setState({ lastName: value });
                break;
            case 3:
                this.setState({ staffId: value });
                break;
            case 4:
                this.setState({ identidyNo: value });
                break;
            case 5:
                this.setState({ gender: parseInt(value) });
                break;
            case 6:
                this.setState({ dob: value });
                break;
            case 7:
                this.setState({ race: parseInt(value) });
                break;
            case 8:
                this.setState({ nationality: value });
                break;
            case 9:
                this.setState({ employmentDate: value });
                break;
            case 10:
                this.setState({ department: parseInt(value) });
                break;
            case 11:
                this.setState({ role: parseInt(value) });
                break;
            case 12:
                this.setState({ officeExtNo: value });
                break;
            case 13:
                this.setState({ email: value });
                break;
            case 14:
                this.setState({ password: value });
                break;
            case 15:
                this.setState({ confirmPassword: value });
                break;
            case 16:
                this.setState({ streetName: value });
                break;
            case 17:
                this.setState({ blkNo: value });
                break;
            case 18:
                this.setState({ unitNo: value });
                break;
            case 19:
                this.setState({ postal: value });
                break;
            case 20:
                this.setState({ homeTel: value });
                break;
            case 21:
                this.setState({ handPhone: value });
                break;
            case 22:
                this.setState({ emgName: value });
                break;
            case 23:
                this.setState({ emgContactNo: value });
                break;
            case 24:
                this.setState({ emgRelationship: value });
                break;
            case 25:
                comHandphone.number = value;
                this.setState({ comHandphone: comHandphone });
                break;
            case 26:
                comHandphone.model = value;
                this.setState({ comHandphone: comHandphone });
                break;
            case 27:
                comHandphone.serial = value;
                this.setState({ comHandphone: comHandphone });
                break;
            case 28:
                comLaptop.number = value;
                this.setState({ comLaptop: comLaptop });
                break;
            case 29:
                comLaptop.model = value;
                this.setState({ comLaptop: comLaptop });
                break;
            case 30:
                comLaptop.serial = value;
                this.setState({ comLaptop: comLaptop });
                break;
            case 31:
                comCabcard.number = value;
                this.setState({ comCabcard: comCabcard });
                break;
            case 32:
                comCabcard.model = value;
                this.setState({ comCabcard: comCabcard });
                break;
            case 33:
                comCabcard.serial = value;
                this.setState({ comCabcard: comCabcard });
                break;
            case 34:
                this.setState({ education: parseInt(value) });
                break;
            case 35:
                this.setState({ school: value });
                break;
            case 36:
                this.setState({ typeIdentidy: value });
                break;
            case 37:
                this.setState({ startWork: value });
                break;
            case 38:
                this.setState({ endWork: value });
                break;
            case 39:
                this.setState({ startLunch: value });
                break;
            case 40:
                this.setState({ endLunch: value });
                break;
            case 41:
                this.setState({ status: parseInt(value) });
                break;
            case 42:
                this.setState({ remark: value });
                break;
        }
    }
    handleCheckBox(e) {
        let checked = e.target.checked;
        this.setState({
            otClaim: checked
        });
    }
    handleUpload(e) {
        let file = e.target.files[0];
        if (this.checkFileExt(file)) {
            this.previewImage(file);
            this.setState({ warningMsg: '' });
        } else {
            this.setState({ warningMsg: 'Only jpg, jpeg and png are allowed' });
        }
    }
    shouldModalClose(data) {
        this.setState({ modalClose: data });
    }
    shouldSupModalClose(data) {
        this.setState({ modalSupClose: data });
    }
    checkFileExt(file) {
        let allow_type = ['jpg', 'jpeg', 'png'];
        let ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        let re = false;
        for (let i = 0; i < allow_type.length; i++) {
            if (ext == allow_type[i].toLocaleLowerCase()) { re = true; break; }
        }
        return re;
    }
    previewImage(file) {
        let userImage;
        //to be modified
        let fr = new FileReader();
        fr.onload = (e) => {
            userImage = window.URL.createObjectURL(new Blob([e.target.result]));
            this.setState({ userImage: userImage });
        };
        fr.readAsArrayBuffer(file);
    }
    handleClick(e) {

        if (this.state.processing) return;

        if (!this.validateForm()) return;


        let fd = new FormData();
        //convert image to blob data
        if (this.state.userImage) {
            let blobData = renderImage.resizeImage(this.state.userImage);
            fd.append("images", blobData);
        }
        let s = this.state;

        fd.append("firstName", s.firstName);
        fd.append("middleName", s.middleName);
        fd.append("lastName", s.lastName);
        fd.append("staffId", s.staffId);
        fd.append("typeIdentidy", s.typeIdentidy);
        fd.append("identidyNo", s.identidyNo);
        fd.append("gender", s.gender);
        fd.append("dob", s.dob);
        fd.append("race", s.race);
        fd.append("nationality", s.nationality);
        fd.append("employmentDate", s.employmentDate);
        fd.append("department", s.department);
        fd.append("role", s.role);
        fd.append("officeExtNo", s.officeExtNo);
        fd.append("email", s.email);
        fd.append("password", s.password);
        fd.append("streetName", s.streetName);
        fd.append("blkNo", s.blkNo);
        fd.append("unitNo", s.unitNo);
        fd.append("postal", s.postal);
        fd.append("homeTel", s.homeTel);
        fd.append("handPhone", s.handPhone);
        fd.append("emgName", s.emgName);
        fd.append("emgContactNo", s.emgContactNo);
        fd.append("emgRelationship", s.emgRelationship);
        fd.append("comHandphone", JSON.stringify(s.comHandphone));
        fd.append("comLaptop", JSON.stringify(s.comLaptop));
        fd.append("comCabcard", JSON.stringify(s.comCabcard));
        fd.append("education", s.education);
        fd.append("school", s.school);
        fd.append("supervisor", JSON.stringify(s.supervisor));
        fd.append("otClaim", s.otClaim ? 1 : 0);
        fd.append("startWork", s.startWork);
        fd.append("endWork", s.endWork);
        fd.append("startLunch", s.startLunch);
        fd.append("endLunch", s.endLunch);
        fd.append("status", s.status);
        fd.append("remark", s.remark);
        //fd.append("permission", JSON.stringify(s.permission));
        userSetAction.processing(true);
        userSetAction.addNewUser(fd);


    }
    validateForm() {
        let isComplete = false;

        if (this.state.userName == "") {
            this.setState({ warningMsg: "Staff Name cannot be empty" });
        } else if (this.state.email == "") {
            this.setState({ warningMsg: "Email cannot be empty" });
        } else if (!this.validateEmail(this.state.email)) {
            this.setState({ warningMsg: "Email is not Valid" });
        } else if (!this.validatePassword(this.state.password)) {
            this.setState({ warningMsg: "Password must be >= 8 characters and at least One Capital Letter" });
        } else if (this.state.password !== this.state.confirmPassword) {
            this.setState({ warningMsg: "Password is not tallied" });
        } else if (this.state.staffId == "") {
            this.setState({ warningMsg: "Employee Number cannot be emptied" });
        } else if (!this.validateStaffId()) {
            this.setState({ warningMsg: "Employee Number repeated" });
        } else {
            this.setState({ warningMsg: "" });
            isComplete = true;
        }

        return isComplete;

    }
    validateStaffId() {
        let isValid = true;

        let len = this.props.staffs.length;
        for (let i = 0; i < len; i++) {
            if (this.props.staffs.staffId == this.state.staffId) {
                isValid = false;
                break;
            }
        }
        return isValid;
    }
    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    validatePassword(password) {
        if (password.length < 8) {
            return false;
        } else if (password.match(/[A-Z]/g) == null) {
            return false;
        }
        return true;
    }
    renderDepartment() {
        return this.props.departmentTxt.map((department, index) => {
            return (<option value={index} key={index}>{department}</option>);
        });
    }
    renderDesignation() {
        return this.props.roleTxt.map((role, index) => {
            return (<option value={index} key={index}>{role}</option>);
        });
    }
    renderSupervisor(supervisor) {
        if (!supervisor) return;
        let spvr = supervisor.map((staff, index) => {
            return (
                <li key={index} className="us-item">{staff.userName}</li>
            );
        });

        return (
            <ol>
                {spvr}
            </ol>
        )
    }
    render() {
        let s = this.state;
        let modal = '';
        if (this.state.modalSupClose) {
            modal = (
                <SupervisorModal
                    modalClose={this.state.modalSupClose}
                    shouldModalClose={this.shouldSupModalClose}
                    staffIds={s.supervisor}
                    staffs={this.props.staffs}
                    title="Reporting Manager"
                />
            );
        }
        return (
            <div className="userSet-form">
                <div className="row">
                    <h3><b>Create New Account</b></h3>
                    <h4><b>Employee Details</b></h4>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="userName">Employee Name</label>
                            <input type="text" className="form-control us-un" value={s.firstName}
                                placeholder="First Name" data-index="0" onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un" value={s.middleName}
                                placeholder="Middle Name" data-index="1" onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un" value={s.lastName}
                                placeholder="Last Name" data-index="2" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="staffId">Employee Id</label>
                            <input type="text" className="form-control" id="staffId" value={s.staffId}
                                placeholder="Employee Number" data-index="3" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="typeIdentidy">Identity Type</label>
                            <input type="text" className="form-control" id="typeIdentidy" value={s.typeIdentidy}
                                placeholder="E.g. S-pass" data-index="36" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="identidyNo">Identity Number</label>
                            <input type="text" className="form-control" id="identidyNo" value={s.identidyNo}
                                placeholder="e.g: SXXXXXXXI" data-index="4" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="gender">Gender</label>
                            <select className="form-control" id="gender" data-index="5" value={s.gender} onChange={this.handleEdit}
                                disabled={s.status != 0} >
                                <option value="0">Male</option>
                                <option value="1">Female</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="dob">D.O.B</label>
                            <input type="date" className="form-control" id="dob" value={s.dob}
                                data-index="6" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="race">Race</label>
                            <select className="form-control" id="race" data-index="7" value={s.race} onChange={this.handleEdit}
                                disabled={s.status != 0} >
                                <option value="0">Chinese</option>
                                <option value="1">Malay</option>
                                <option value="2">Indian</option>
                                <option value="3">Other</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="nation">Nationality</label>
                            <input type="text" className="form-control" id="nation" value={s.nationality}
                                placeholder="Nationality" data-index="8" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="education">Level of Education</label>
                            <select className="form-control" id="education" data-index="34" value={s.education} onChange={this.handleEdit}
                                disabled={s.status != 0} >
                                <option value="0">Primary</option>
                                <option value="1">N-level</option>
                                <option value="2">O-level</option>
                                <option value="3">GCE 'A' Level</option>
                                <option value="4">Diploma</option>
                                <option value="5">Bachelor</option>
                                <option value="6">Master</option>
                                <option value="7">Other</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="school">Name of School (Highest level)</label>
                            <input type="text" className="form-control" id="school" value={s.school}
                                placeholder="Name of University or polytechnic" data-index="35" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="employmentDate">Employment Date</label>
                            <input type="date" className="form-control" id="employmentDate" value={s.employmentDate}
                                data-index="9" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="status">Employment Status</label>
                            <select className="form-control" id="status" data-index="41" value={s.status} onChange={this.handleEdit} >
                                <option value="0">Employed</option>
                                <option value="1">Resigned</option>
                                <option value="2">Dismissed</option>
                                <option value="3">Terminated</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="department">Department</label>
                            <select className="form-control" id="department" value={s.department} data-index="10" onChange={this.handleEdit}
                                disabled={s.status != 0} >
                                {this.renderDepartment()}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="designation">Designation</label>
                            <select className="form-control" id="designation" value={parseInt(s.role)} data-index="11" onChange={this.handleEdit}
                                disabled={s.status != 0} >
                                {this.renderDesignation()}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="officeExtNo">Office Ext No.</label>
                            <input type="number" className="form-control" id="officeExtNo"
                                placeholder="Office Ext No." data-index="12" value={s.officeExtNo} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email address</label>
                            <input type="email" className="form-control" id="email"
                                placeholder="Email" data-index="13" value={s.email} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password (For App & Webportal Login)</label>
                            <input type="password" className="form-control" id="password"
                                placeholder="must be >= 8 and at least one Capital Letter" data-index="14" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input type="password" className="form-control" id="confirmPassword"
                                placeholder="re-type your password" data-index="15" onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="supervisor">Reporting Manager</label>
                            {this.renderSupervisor(s.supervisor)}
                            <button className="btn btn-default btn-sm us-edit" onClick={this.addSupervisor}>Edit</button>
                        </div>
                        <div className="form-group">
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" value={s.otClaim} onChange={this.handleCheckBox} checked={s.otClaim} disabled={s.status != 0} />
                                    <span className="checkmark"></span>
                                    OT Claim
                                </label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="remark">Remark</label>
                            <textarea className="form-control" id="remark" rows="3"
                                placeholder="Type Remark Here" data-index="42" value={s.remark} onChange={this.handleEdit}
                                disabled={s.status != 0} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="userImage">Staff Picture Upload</label>
                            <input type="file" id="userImage" onChange={this.handleUpload} disabled={s.status != 0} />
                            <p className="help-block">Picture Format (150x200). Accept .jpg, .jpeg, .png format</p>
                        </div>
                        <div className="ui-pre-w">
                            <img className="ui-pre" src={s.userImage} attribute="staff Picture Preview" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="startWork">Start Work.</label>
                            <input type="time" className="form-control" id="startWork"
                                data-index="37" value={s.startWork} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="endWork">End Work</label>
                            <input type="time" className="form-control" id="endWork"
                                data-index="38" value={s.endWork} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="startLunch">Lunch Time Start</label>
                            <input type="time" className="form-control" id="startLunch"
                                data-index="39" value={s.startLunch} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="endLunch">Lunch Time End</label>
                            <input type="time" className="form-control" id="endLunch"
                                data-index="40" value={s.endLunch} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>

                    </div>
                </div>
                <div className="row">
                    <h4><b>Residential Address</b></h4>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="streetName">STREET NAME</label>
                            <input type="text" className="form-control" id="streetName"
                                placeholder="e.g. Thomson Road" data-index="16" value={s.streetName} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="blkNo">APT/BLK NO.</label>
                            <input type="text" className="form-control" id="blkNo"
                                placeholder="e.g. Blk 184" data-index="17" value={s.blkNo} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="unitNo">UNIT NO.</label>
                            <input type="text" className="form-control" id="unitNo"
                                placeholder="e.g. 10-113" data-index="18" value={s.unitNo} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                    <div className="col-md-4">

                        <div className="form-group">
                            <label htmlFor="postal">POSTAL CODE</label>
                            <input type="text" className="form-control" id="postal"
                                placeholder="e.g. 611001" data-index="19" value={s.postal} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="homeTel">Home Tel.</label>
                            <input type="text" className="form-control" id="homeTel"
                                placeholder="Home Tel" data-index="20" value={s.homeTel} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="handPhone">HAND PHONE</label>
                            <input type="text" className="form-control" id="handPhone"
                                placeholder="e.g. 9XXXXXXX" data-index="21" value={s.handPhone} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <h4 className="us-em-tt">Emergency Contact</h4>
                        <div className="form-group">
                            <label htmlFor="emgName">NAME</label>
                            <input type="text" className="form-control" id="emgName"
                                placeholder="Type name here" data-index="22" value={s.emgName} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="emgContactNo">CONTACT NO</label>
                            <input type="text" className="form-control" id="emgContactNo"
                                placeholder="e.g. 9XXXXXXX" data-index="23" value={s.emgContactNo} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="emgRelationship">RELATIONSHIP</label>
                            <input type="text" className="form-control" id="emgRelationship"
                                placeholder="e.g. brother" data-index="24" value={s.emgRelationship} onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <h4><b>Company Issue</b></h4>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="comHandphone">HANDPHONE</label>
                            <input type="text" className="form-control us-un" id="comHandphone"
                                placeholder="Number" data-index="25" value={s.comHandphone ? s.comHandphone.number : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un"
                                placeholder="Model" data-index="26" value={s.comHandphone ? s.comHandphone.model : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un"
                                placeholder="Serial" data-index="27" value={s.comHandphone ? s.comHandphone.serial : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="comLaptop">Laptop</label>
                            <input type="text" className="form-control us-un" id="comLaptop"
                                placeholder="Number" data-index="28" value={s.comLaptop ? s.comLaptop.number : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un"
                                placeholder="Model" data-index="29" value={s.comLaptop ? s.comLaptop.model : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un"
                                placeholder="Serial" data-index="30" value={s.comLaptop ? s.comLaptop.serial : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="comCabcard">CAB CARD</label>
                            <input type="text" className="form-control us-un" id="comCabcard"
                                placeholder="Number" data-index="31" value={s.comCabcard ? s.comCabcard.number : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un"
                                placeholder="Model" data-index="32" value={s.comCabcard ? s.comCabcard.model : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                            <input type="text" className="form-control us-un"
                                placeholder="Serial" data-index="33" value={s.comCabcard ? s.comCabcard.serial : ""}
                                onChange={this.handleEdit} disabled={s.status != 0} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="warning">{this.state.warningMsg}</div>
                        <button type="button" className="btn btn-warning us-cr"
                            data-index="0" onClick={this.handleClick}>Create</button>

                    </div>
                    <div className="clear"></div>
                </div>
                <UserSetModal
                    modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose}
                    usMode={this.props.usMode} />
                {modal}
            </div>
        );
        /*
<div className="row">
            <h4><b>Permission</b></h4>
            <UserPermission permission={s.permission} permissionList={this.state.permissionList} />
        </div>
        */
    }
}
export default UserSetForm;


// WEBPACK FOOTER //
// ./app/setComponents/userSetComponents/userSetForm.js